import validate from 'validate.js'
import uuid from 'uuid/v1'
import {
    conformToMask
} from 'text-mask-core'

const identityValidator = (value) => {
    const a = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'I', 'O');
    const b = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
    const c = new Array(2);

    let d, e, f, g = 0,
        h = /^[a-z](1|2)\d{8}$/i;

    if (value.search(h) == -1) {
        return false;
    } else {
        d = value.charAt(0).toUpperCase();
        f = value.charAt(9);
    }
    for (let i = 0; i < 26; i++) {
        if (d == a[i]) //a==a
        {
            e = i + 10; //10
            c[0] = Math.floor(e / 10); //1
            c[1] = e - (c[0] * 10); //10-(1*10)
            break;
        }
    }
    for (let i = 0; i < b.length; i++) {
        if (i < 2) {
            g += c[i] * b[i];
        } else {
            g += parseInt(value.charAt(i - 1)) * b[i];
        }
    }
    if ((g % 10) == f) {
        return true;
    }
    if ((10 - (g % 10)) != f) {
        return false;
    }
    return true;
}

validate.validators.identityROC = (value, options, key, attributes) => {
    const valid = identityValidator(value)
    return (valid) ? undefined : options.message
};

validate.validators.invalid = (value, options, key, attributes) => {
    return options.message
};


let _default_guid = "00000000-0000-0000-0000-000000000000",
    _loading = false,
    _data = [],
    _pageIndex = 1,
    _queryString = '',
    _paging = {
        pageCount: 0,
        pageNo: 1,
        pageSize: 0,
        totalRecordCount: 0
    }



class BaseModel {

    constructor(args) {
        this.constraints = args
        this.errors = []
    }

    static get DEFAULT_GUID() {
        return DEFAULT_GUID
    }

    static get loading() {
        return _loading
    }

    static set loading(value) {
        _loading = value
    }

    static get data() {
        return _data
    }

    static set data(value) {
        _data = value
    }

    static get pageIndex() {
        return _pageIndex
    }

    static set pageIndex(value) {
        _pageIndex = value
    }

    static get queryString() {
        return _queryString
    }

    static set queryString(value) {
        _queryString = value
    }

    static get paging() {
        return _paging
    }

    static set paging(value) {
        _paging = value
    }

    static maskvalue(value, regex) {
        const maskObject = conformToMask(value, regex, {
            guide: false
        })
        return maskObject.conformedValue
    }

    static padLeft(str, len) {
        str = '' + str;
        if (str.length >= len) {
            return str;
        } else {
            return this.padLeft("0" + str, len);
        }
    }

    uuid() {
        return uuid()
    }

    identityValidator(value) {
        return identityValidator(value)
    }

    valid(field) {
        let error = validate.single(this[field], this.constraints[field])
        this.errors = this.errors || []
        this.errors[field] = error
        return error ? error[0] : null
    }
    error(field) {
        return (this.errors && this.errors[field]) ? this.errors[field][0] : null
    }
    validate() {
        const data = this
        this.errors = validate(data, this.constraints)
        return this.errors || false
    }
    clear(object) {
        if (object.hasOwnProperty('data')) {
            delete object.data
        }
        return JSON.parse(JSON.stringify(object))
    }

    ajaxError(e) {
        const msg = JSON.parse(e)
        if (msg.hasOwnProperty('Error')) {
            return msg.Error.toString()
        }
        let errros = []
        Object.keys(msg).map(function (objectKey, index) {
            var value = msg[objectKey];
            errros.push(value)
        })
        return (errors) ? errors.toString() : false
    }

    static Storage(method, itemName, data) {
        let result
        switch (method) {
            case 'GET':
                result = localStorage.getItem(itemName)
                result = JSON.parse(result)
                break
            case 'SET':
                data = JSON.stringify(data)
                localStorage.setItem(itemName, data)
                break
        }

        return new Promise((resolve, reject) => {
            resolve(result)
        })
    }
}

export default BaseModel